import { OutboundDataTypeSchema } from '@standandforce/api-contract';
import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';

/**
 * OUT 一覧のクエリ Schema。IN `_list/-constants.SearchSchema` と同型方針。
 * - pageIndex / pageSize / sortColumn / sortOrder（IN と完全同型）
 * - dataType: OUT 固有のフィルタ（未指定で全件）。値集合は contract を SSoT とし、
 *   画面側で書き起こさない（BE が dataType を増やしたときに絞り込めなくなるため）
 */
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  dataType: OutboundDataTypeSchema.optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional()
});